import * as d3 from "d3";

export class Scales {
  xScale: d3.ScaleTime<number, number, never>;
  yScale: d3.ScaleLinear<number, number, never>;

  constructor() {
    this.xScale = d3.scaleTime();
    this.yScale = d3.scaleLinear();
  }

  setScales(
    innerWidth: number,
    innerHeight: number,
    minYAxisValue: number,
    maxYAxisValue: number,
    startDate: Date,
    endDate: Date,
  ) {
    this.setXScales(innerWidth, startDate, endDate);
    this.setYScales(innerHeight, minYAxisValue, maxYAxisValue);
  }

  setXScales(innerWidth: number, startDate: Date, endDate: Date) {
    this.xScale
      // adjust to the available screen area
      .range([0, innerWidth])
      .domain([startDate, endDate]);
  }

  setYScales(innerHeight: number, minYAxisValue: number, maxYAxisValue: number) {
    const yRange = maxYAxisValue - minYAxisValue;
    this.yScale
      // adjust to the available screen area
      .rangeRound([innerHeight, 0])
      // adjust to the available screen area
      // add a bit of percentage padding to either end
      .domain([minYAxisValue - yRange * 0.1, maxYAxisValue + yRange * 0.1]);
  }

  static calculateMaxMinYAxisValues(
    balances: Map<string, number>,
    insByTime: Map<string, number>,
    outsByTime: Map<string, number>,
  ) {
    // using the data from the balance graph and the scenario
    // work out the upper and lower boundaries of the y-axis
    let maxYAxisValue: number = -Infinity;
    let minYAxisValue: number = Infinity;

    const balancesArray = Array.from(balances.values());
    const insArray = Array.from(insByTime.values());
    const outsArray = Array.from(outsByTime.values());

    balancesArray.forEach((value: number, index: number) => {
      if (index !== insArray.length - 1) {
        let maxValue = value;
        let minValue = value;
        if (insArray?.[index + 1]) {
          maxValue = value + insArray[index + 1];
        }
        if (outsArray?.[index + 1]) {
          minValue = value - outsArray[index + 1];
        }
        if (maxValue > maxYAxisValue) {
          maxYAxisValue = maxValue;
        }
        if (minValue < minYAxisValue) {
          minYAxisValue = minValue;
        }
      }
    });
    return [minYAxisValue, maxYAxisValue];
  }

  static calculateMaxMinYAxisValuesList(
    balances: Map<string, number>[],
    insByTime: Map<string, number>[],
    outsByTime: Map<string, number>[],
  ) {
    // using the data from the balance graph and the scenario
    // work out the upper and lower boundaries of the y-axis
    let maxYAxisValue: number = -Infinity;
    let minYAxisValue: number = Infinity;

    balances.forEach((balanceSet, index) => {
      const insSet = insByTime[index] || new Map<string, number>();
      const outsSet = outsByTime[index] || new Map<string, number>();

      const [newMinYAxisValue, newMaxYAxisValue] = this.calculateMaxMinYAxisValues(
        balanceSet,
        insSet,
        outsSet,
      );

      if (newMinYAxisValue < minYAxisValue) {
        minYAxisValue = newMinYAxisValue;
      }
      if (newMaxYAxisValue > maxYAxisValue) {
        maxYAxisValue = newMaxYAxisValue;
      }
    });

    return [minYAxisValue, maxYAxisValue];
  }
}
